App.BonusCategoriesIndexController = Em.Controller.extend
  bonusCategoriesBinding: 'model'

  env:                      Em.inject.service('environment')
  bonusCategoriesEnabled:   Em.computed.alias('env.features.bonusCategories')

  actions:
    openBonusCategory: (bonusCategory) ->
      @transitionToRoute 'bonus-categories.bonus-category.edit', bonusCategory.get('id')